var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticClass:"map_full",attrs:{"center":_vm.center,"options":_vm.mapStyle,"zoom":11}},[_c('gmap-polygon',{attrs:{"paths":_vm.paths}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }